<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import moment from 'moment'
    export default {
        name: 'pieCharts',
        props: {
            'pieData': Array,
            'pieRatio':String
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    legend: {},
                    series: {}
                },
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            // echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
           
        },
        computed: {
        },
        watch: {
            pieData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            },
            pieRatio:function(newValue,oldValue){
                if(newValue!= oldValue){
                    this.echartObj.setOption(this.setSeriesData(), true);
                }
            }
        },
        methods: {
            getXaxisData () {
                // 填入横轴数据
                if (this.pieData.length > 0) {
                    return this.pieData.map(item => {
                        return item.name;
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                return this.pieData
            },
            setSeriesData () {
                this.setOptions('legend', (() => {
                    return {
                        orient: 'horizontal',
                        y: 'bottom',
                        icon: 'circle',
                        icon: "rect",
                        itemWidth:7,  // 设置宽度
                        itemHeight:7, // 设置高度
                        selectedMode: false,
                        itemGap: 24,
                        textStyle: {
                            color:"#999",
                            fontSize:10
                        },
                        data: this.getXaxisData()
                    }
                })());
                this.setOptions('title',(()=>{
                return{
                        text: this.pieRatio + "%",
                        x: 'center',
                        y: 'center',
                        textStyle: {
                            color: 'rgba(54,179,116,1)',
                            fontWeight: 'bold',
                            fontSize: 20,
                            fontWeight: 'normal'
                        },
                    }
              
                })());
                this.setOptions('series', (() => {
                    let that = this
                    return {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['50%', '60%'],
                        avoidLabelOverlap: false,
                        hoverAnimation: false,
                        clockwise:false,
                        silent: true,
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: this.getSeriesData(),
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    // 自定义颜色
                                    var colorList = [
                                        'rgba(54,179,116,0.2)','rgba(54,179,116,1)'
                                    ];
                                    return colorList[params.dataIndex]
                                },
                                label:{
                                    show:false
                                }
                            }
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
}
</style>
